<template>
  <section>
    <!--工具条-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
      <el-form :inline="true" :model="filters">
        <el-form-item label="设备ID:">
          <el-input v-model="filters.deviceNo" placeholder="设备ID" style="width:170px;" icon="circle-close"
                    :on-icon-click="cleanDevice"></el-input>
        </el-form-item>
        <el-form-item label="掉线类型:">
          <el-radio-group v-model="filters.type">
            <el-radio :label="null">全部</el-radio>
            <el-radio :label="0">断线</el-radio>
            <el-radio :label="1">信号差</el-radio>
            <el-radio :label="2">设备故障</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="事件时间:">
          <el-date-picker
                  v-model="filters.eventDate"
                  type="date"
                  placeholder="选择时间"
                  align="right" style="width:130px;">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" v-on:click="search()" size="small">查询</el-button>
        </el-form-item>
      </el-form>
    </el-col>

    <!--列表-->
    <el-table :data="logs" border highlight-current-row v-loading="listLoading"
              style="width: 100%;">
      <el-table-column header-align="center" align="center" prop="deviceNo" label="设备ID" width="180">
      </el-table-column>
      <el-table-column header-align="center" align="center" prop="type" :formatter="formatType" label="掉线类型" min-width="60">
      </el-table-column>
      <el-table-column header-align="center" align="center" prop="eventDate" :formatter="formatTime" label="事件时间" min-width="80">
      </el-table-column>
      <el-table-column
              header-align="center"
              align="center"
              prop="customerName" label="客服姓名"
              min-width="90">
      </el-table-column>
      <el-table-column header-align="center" align="center" prop="remark" label="备注" min-width="200">
      </el-table-column>
      <el-table-column header-align="center" align="center" prop="createdAt" :formatter="formatTime2" label="创建时间" min-width="100">
      </el-table-column>
      <!--<el-table-column label="操作" width="150" align="center">-->
        <!--<template scope="scope">-->
          <!--<el-button type="primary" size="small" :disabled="scope.row.offlineCount <= 0 || scope.row.disposed" @click="handleAdd(scope.$index, scope.row)">原因提交</el-button>-->
        <!--</template>-->
      <!--</el-table-column>-->
    </el-table>

    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="10" :total="total"
                     style="float:right;">
      </el-pagination>
    </el-col>
  </section>
</template>

<script>
  import util from '../../common/js/util'
  import moment from 'moment'
  import bcrypt from 'bcryptjs'
  //import NProgress from 'nprogress'
  import {getServiceLogList} from '../../api/api';

  export default {
    data() {
      return {
        filters: {
          deviceNo: '',
          type: null,
          eventDate: ''
        },
        total: 0,
        page: 1,
        listLoading: false,
        logs:[],
      }
    },
    methods: {
      cleanDevice() {
        this.filters.deviceNo = '';
      },
      formatTime: function (row, column) {
        return moment(row.eventDate).format('YYYY-MM-DD');
      },
      formatType: function (row, column) {
        switch(row.type) {
          case 0:
            return '断电';
          case 1:
            return '信号差';
          case 2:
            return '设备故障';
        }
      },
      formatTime2: function (row, column) {
        return moment(row.createdAt).format('YYYY-MM-DD HH:mm:ss');
      },
      handleCurrentChange(val) {
        this.page = val;
        this.search();
      },
      search() {
        let para = {
          page: this.page,
          size: 10,
          deviceNo: this.filters.deviceNo,
          type: this.filters.type,
          eventDate: this.filters.eventDate ? moment(this.filters.eventDate).valueOf():'',
        };
        this.listLoading = true;
        //NProgress.start();
        getServiceLogList(para).then((res) => {
          this.logs = res.data.list;
          this.listLoading = false;
          this.total = res.data.total;
          //NProgress.done();
        });
      },

    },
    mounted() {
      this.search();
    }
  }

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// ServiceLog.vue?213752ce